import React, {BaseSyntheticEvent, useCallback, useEffect, useState} from "react";
import {UserIcon} from "./icons/icons/UserIcon";
import {SettingsIcon} from "./icons/icons/SettingsIcon";
import {HelpIcon} from "./icons/icons/HelpIcon";
import {ExitIcon} from "./icons/icons/ExitIcon";
import {Link, useNavigate} from "react-router-dom";
import DropDown, {OptionsAlign} from "./DropDown/DropDown";
import {useTranslation} from "react-i18next";
import {DropDownOptionType} from "./DropDown/Option";
import HeaderLogo from "./HeaderLogo/HeaderLogo";
import {useAuth} from "../context/authContext";
import ThemeSetter from "./ThemeSetter/ThemeSetter";
import {useTheme} from "../context/themeContext";
import {themeColors} from "../styles/theme";
import {useTypedSelector} from "../redux/Hooks/storeSelectors";
import {selectCurrentProjectId} from "../redux/selectors/selectors";
import LanguageSelector from "./LanguageSelector/LanguageSelector";


type Props = {
  projectName?: string;
}

function Header({projectName}: Props) {
  const projectId = useTypedSelector(selectCurrentProjectId)
  const navigate = useNavigate();
  const {t} = useTranslation();
  const {theme} = useTheme();
  const {user, runLogout} = useAuth();

  function settingsClickHandler(name: string | null) {
    navigate(`/settings/${name}`);
  }

  const onSignOut = async () => {
    await runLogout();
  }

  const openHelpInNewTab = useCallback(() => {
      window.open(
          'https://alkaline-hellebore-06d.notion.site/Replan-Public-Documentation-177e4afbb2c180df8506eab6ded0594d?pvs=4',
          '_blank'
      );
  }, []);

  const dropDownOptions: DropDownOptionType[] = [
    {
      link: '/settings/profile',
      title: t('header.user-profile'),
      onClick: (e: BaseSyntheticEvent) => {
        settingsClickHandler('profile');
      },
      image: <SettingsIcon color={theme === 'light' ? themeColors.bluePurple : themeColors.grey3}/>,
    },
    {
      // link: '/settings/help',
      title: t('header.help'),
      onClick: (e: BaseSyntheticEvent) => {
        openHelpInNewTab();
      },
      image: <HelpIcon color={theme === 'light' ? themeColors.bluePurple : themeColors.grey3}/>,
    },
    {
      // link: '/signout',
      replace: true,
      title: t('header.exit'),
      onClick: onSignOut,
      image: <ExitIcon color={theme === 'light' ? themeColors.bluePurple : themeColors.grey3}/>,
    }
  ]

  return (
    <header className={`header ${theme}`}>
      <div className="header__tab-block">
        <Link to="/">
          <div className={`${theme} logo-wrapper`}>
            <HeaderLogo/>
          </div>
        </Link>
        {
            projectName && (
                <div className="tab-content">
                  <span className={`${theme} tab-text`}>
                    <Link
                        style={{color: themeColors.grey, display: 'unset', flexGrow: 0}}
                        to={`/${projectId}`}
                    >
                      {projectName}
                    </Link>
                  </span>
                </div>
            )
        }
      </div>
      <div className="header__right-block">
        <DropDown
          options={dropDownOptions}
          title={
          <div className="header__user-dropdown-title">
            <span>{user}</span>
            <span><UserIcon color={theme === 'light' ? themeColors.grey : themeColors.grey3}/></span>
          </div>
            }
          outlined={false}
          optionsAlign={OptionsAlign.RIGHT}
          optionColorLight={themeColors.navyBlue}
          optionColorDark={themeColors.white}
          iconColorDark={themeColors.grey3}
        />
        <div className="lang-selector">
          <LanguageSelector/>
        </div>
        <ThemeSetter/>
      </div>
    </header>
  );
}

export default Header;
